import {
  SOCIAL_EXTRACTION_STATUS,
  type SocialExtractionStatus,
} from "contracts/enums/social";

export const SOCIAL_EXTRACTION_STATUS_LABELS: Record<
  SocialExtractionStatus,
  string
> = {
  [SOCIAL_EXTRACTION_STATUS.QUEUED]: "Queued",
  [SOCIAL_EXTRACTION_STATUS.STARTING]: "Starting Actor",
  [SOCIAL_EXTRACTION_STATUS.RUNNING]: "Extracting",
  [SOCIAL_EXTRACTION_STATUS.IMPORTING]: "Importing captures",
  [SOCIAL_EXTRACTION_STATUS.STOPPING]: "Stopping",
  [SOCIAL_EXTRACTION_STATUS.STOPPED]: "Stopped",
  [SOCIAL_EXTRACTION_STATUS.COMPLETED]: "Completed",
  [SOCIAL_EXTRACTION_STATUS.FAILED]: "Failed",
  [SOCIAL_EXTRACTION_STATUS.START_AMBIGUOUS]: "Actor start needs inspection",
};
